import { Component, Input } from '@angular/core';
import { okpd, docType } from './ex-ev-okpd';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {environment} from '@environments/environment';
import {FormsService} from "@app/_services";
import { min } from 'rxjs/operators';


@Component({
  selector: 'express-evaluation',
  templateUrl: './express-evaluation.component.html',
  styleUrls: ['./express-evaluation.component.scss']
})
export class ExpressEvaluationComponent {
  @Input() pageName:string;
  page: number = 0;
  production:string;
  role: boolean;
  proceeding:boolean;
  experience:string;
  management:string;
  conditions={
    min:false,
    mid:false,
    max:false
  }

  survey = true
  final=false;
  application = false;
  userResp = false;

  productionList=okpd;

  result: number;

  routeSubscription:Subscription;
  pageURL: string;

  applicant = {
    company:'',
    fcs:'',
    phone:'',
    email:'',
  }

  constructor(private router: Router, private formsService: FormsService) {
    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) this.pageURL = event.url
    });
  }

  ngOnInit(){
    this.pageURL = this.router.url;
  }

  ngOnDestroy() {
    document.body.style.top ='';
    document.body.style.position = '';
    this.routeSubscription?.unsubscribe();
  }

  get visible(){
    return this.router.url === this.pageName
  }

  start(){
    this.page=1;
    this.final = false;
    this.survey = true;
    this.application = false;
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';

  }

  finish(){
    this.page = 0;
    document.body.style.position = '';
    this.userResp = null;
    this.survey = true;
  }


  setProduction(event){
    this.production = event;
  }



  nextPage(){
    if (this.page === 5) {this.final = true; this.survey = false;} else {this.page++};
  }

  get applicantComplete(){
    return this.applicant.company && this.applicant.fcs && this.applicant.email && this.applicant.phone
  }



  get summary(){
    let  summ=0;
    summ += this.production ? 40 : 0;
    summ += this.proceeding? 5 : 0;
    summ += this.experience==='min' ? 5 : this.experience==='mid' ? 10 : this.experience==='max' ? 15 : 0;
    summ += this.management==='min' ? 5 : this.management==='mid' ? 10 : this.management==='max' ? 15 : 0;
    summ += this.conditions.min ? 5 : 0;
    summ += this.conditions.mid ? 10 : 0;
    summ += this.conditions.max ? 9 : 0;
    return summ
  }

  get summaryStyle(){
    let gradient = `conic-gradient(#11AC00 ${this.summary}%, #11AC00 ${this.summary}%, #EDEDED ${this.summary}%, #EDEDED 100%)`
    return {
      'background': gradient
    }
  }

  mail(){
    let data = {
      'mailto': 'kazakov_ia@vniigaz-cert.ru',
      'type':  'express-evaluation-form',
      'company-name': this.applicant.company,
      'applicant-name': this.applicant.fcs,
      'contact-phone': this.applicant.phone,
      'contact-email': this.applicant.email,
      'production': this.production||'—',
      'proceeding': this.proceeding===true?'Да':this.proceeding===false?'Нет':'—',
      'experience': (this.experience==='min'&&'Есть опыт поставок в другие отрасли')||(this.experience==='mid'&&'Есть опыт поставок на объекты иных нефтегазовых компаний')||(this.experience==='max'&&'Есть опыт поставок на объекты ПАО "Газпром"')||'—',
      'management': (this.management==='min'&&'остутсвует')||(this.management==='mid'&&'по ГОСТ Р ИСО 9001 или иным стандартам')||(this.management==='max'&&'СТО Газпром 9001')||'—',
      'conditions': [(this.conditions.min&&'Наличие технических условий на продукцию'),(this.conditions.mid&&'Наличие комплекта КД'),(this.conditions.max&&'Наличие протоколов квалификационных/периодических испытаний продукции')].filter(val=>val).join('; ')||'—',
    }

    // window.open(`mailto:admin@nirgroup.ru?subject=${subject }&body=${body.join('%0D%0A')}`);

    this.formsService.save('model', 'express-evaluation-form', null, data).subscribe(res => {
      this.application = false;
      this.userResp = true;
    }, errore => {
      console.log(errore)
    });
  }

  sertification(){
    this.final = false;
    this.survey = false;
    this.application = true;
  }


}
